import { render, staticRenderFns } from "./ButtonFlat.vue?vue&type=template&id=1dcd6e40&scoped=true"
import script from "./ButtonFlat.vue?vue&type=script&lang=js"
export * from "./ButtonFlat.vue?vue&type=script&lang=js"
import style0 from "./ButtonFlat.vue?vue&type=style&index=0&id=1dcd6e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd6e40",
  null
  
)

export default component.exports